import React, { useMemo } from "react";
import { Form, FormikConfig, FormikProvider, useFormik } from "formik";
import { Trans, useTranslation } from "react-i18next";
import { RenderFormFields } from "src/components/RenderFormFields";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { submitContactFormAsync } from "src/redux/contactUs/actions";
import { selectCountries } from "src/redux/countries/selectors";
import { selectIsLoading } from "src/redux/contactUs/selectors";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as SendIcon } from "src/assets/icons/send.svg";
import { getContactUsFormField } from "./constants/fields";
import { CONTACT_US_FORM_VALIDATION_SCHEMA } from "./constants/validation";
import { contactUsTrns } from "./trns";
import { ContactUsValues } from "./types";

const INITIAL_VALUES: ContactUsValues = {
  name: "",
  email: "",
  phone: "",
  country: "",
  role: "",
  how_we_can_help: "",
};

export const ContactUsForm = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { items: countries } = useAppSelector(selectCountries);
  const isLoading = useAppSelector(selectIsLoading);

  const contactUsField = useMemo(
    () => getContactUsFormField(countries),
    [countries]
  );

  const formikProps: FormikConfig<ContactUsValues> = {
    initialValues: INITIAL_VALUES,
    validationSchema: CONTACT_US_FORM_VALIDATION_SCHEMA,
    onSubmit: (values, { resetForm }) => {
      dispatch(submitContactFormAsync({ values, onSuccess: resetForm }));
    },
  };

  const formik = useFormik<ContactUsValues>(formikProps);

  return (
    <FormikProvider value={formik}>
      <Form className="flex flex-col gap-10 flex-1">
        <Trans
          i18nKey={contactUsTrns.contactUsIntro}
          components={{ br: <br /> }}
        />

        <div className="flex flex-col gap-7 items-start">
          <RenderFormFields fields={contactUsField} />

          <Button
            isLoading={isLoading}
            variant={ButtonVariants.PRIMARY}
            className="flex items-center text-xl justify-center min-w-52 min-h-12 gap-2 px-5 py-3"
          >
            <span>{t(contactUsTrns.sendRequestBtn)}</span>
            <SendIcon className="w-5 h-5 fill-svg-white-base" />
          </Button>
        </div>
      </Form>
    </FormikProvider>
  );
};
